import { generateColumnId } from '../../../utils';
import { columnDefinitions } from './columnDefinitions';
import { DYNAMIC_REPORTS_REPORT_ID } from './dynamicReportsReportId';

export const defaultColumns = columnDefinitions.map(({ field }) => generateColumnId(DYNAMIC_REPORTS_REPORT_ID, field));
